import { render } from "./LeadDialogWhatsAppMessages.vue?vue&type=template&id=5ccbb939&scoped=true"
import script from "./LeadDialogWhatsAppMessages.vue?vue&type=script&lang=js"
export * from "./LeadDialogWhatsAppMessages.vue?vue&type=script&lang=js"

import "./LeadDialogWhatsAppMessages.vue?vue&type=style&index=0&id=5ccbb939&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccbb939"]])

export default __exports__